import React, { useContext, useState } from 'react';
import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from 'react-i18next';
import loadable from '@loadable/component';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { AuthContext } from '../../../Contexts';
const AuthenticateModal = loadable(() =>
  import('../../HomeDeliveryNew/AuthenticateModal')
);
const SignupModal = loadable(() => import('../../common/SignupModal.jsx'));
const SignInModal = loadable(() =>
  import('../../HomeDeliveryNew/AuthenticateModal/signInModal')
);
/* eslint-disable no-undef */
const AddOnGeniusFaq = ({
  mailOrderPricings,
  selectedDisplayQuantity,
  mailOrderTemplate
}) => {
  const [isAuthModal, setIsAuthModal] = useState(false);
  const [isSignUpModal, setIsSignUpModal] = useState(false);
  const [isSignInModal, setIsSignInModal] = useState(false);
  const userData = useContext(AuthContext)?.userData;
  const isLoggedIn = userData?.isLoggedIn;
  const { t } = useTranslation();
  const redirectUrl = url => {
    return _.isEmpty(url)
      ? ''
      : url.replace(
          new RegExp(
            '{{DisplayQuantity}}'.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
            'g'
          ),
          selectedDisplayQuantity
        );
  };
  const onHomeDeliveryClick = () => {
    /*_.triggerGTMVirtualPageViewEvent({
      ...eventObj,
      event: "geniusRxCtaClick",
      clickText: "Home delivery",
      geniusRxPrice: currentPrice
    });*/
    if (!isLoggedIn) {
      setIsAuthModal(true);
    } else {
      /* _.triggerGTMVirtualPageViewEvent({
        ...eventObj,
        event: "geniusRxRedirectLoggedIn",
        formId: userStatus
      });*/
      window.open(redirectUrl(mailOrderPricings.redirectUrl), '_self');
    }
  };
  return (
    <div>
      {!_.isEmpty(mailOrderTemplate) &&
        documentToReactComponents(JSON.parse(mailOrderTemplate))}
      {!_.isEmpty(mailOrderTemplate) && (
        <div className="pharmacy-item__cta">
          <button
            id="geniusrx-homedelivery-faq"
            className="sc-btn-pink rx-get-this-price geniusrx-homedelivery-new geniusrx-homedelivery-cta showCta geniusrx-homedelivery-faq themeFocus"
            onClick={() => onHomeDeliveryClick()}
          >
            <span>
              <LazyLoadImage
                src="/content/images/icons/truck.png"
                height="22px"
                width="22px"
                alt=""
              />
            </span>
            <span className="desktop-only">{t('Home delivery')}</span>
            <span className="mobile-only">{t('Get home delivery')}</span>
          </button>
        </div>
      )}
      {isAuthModal && (
        <AuthenticateModal
          hideAuthenticateModal={() => setIsAuthModal(false)}
          openSignUpModal={() => toggleSignUp()}
          openSignIn={() => openSignIn()}
          redirectUri={mailOrderPricings.redirectUrl}
          quantity={selectedDisplayQuantity}
          isFromHomeDelivery={true}
        />
      )}
      {isSignUpModal && (
        <div className="mainModal afterSignupmodal">
          <div
            className="transparentBg"
            onClick={() => setIsSignUpModal(false)}
          ></div>
          <div className="signUpModal">
            <SignupModal
              isFromHomeDelivery={true}
              closeSignupModal={() => setIsSignUpModal(false)}
              hideSignUpOpenFlashModal={() => hideSignUpOpenFlashModal()}
            />
          </div>
        </div>
      )}
      {isSignInModal && (
        <SignInModal
          redirectUri={mailOrderPricings.redirectUrl}
          hideSignInModal={() => setIsSignInModal(false)}
          hideSignInOpenFlashModal={() => hideSignInOpenFlashModal()}
        />
      )}
    </div>
  );
};
export default React.memo(AddOnGeniusFaq);
